import { Spinner } from '@cabgo/ui';
import { type ReactNode, Suspense } from 'react';

/** Suspend page content without hiding the surrounding navigation or provider selector. */
export function RouteBoundary({ children }: { children: ReactNode }) {
  return (
    <Suspense
      fallback={
        <div className="dash-loading">
          <Spinner />
        </div>
      }
    >
      {children}
    </Suspense>
  );
}
